import { Card, Col, Row } from "antd";
import { useSelector } from "react-redux";
import { Column, Line } from "@ant-design/plots";
import { StarOutlined, RiseOutlined, TeamOutlined } from "@ant-design/icons";
import "../../assets/css/reputation-manager.css";
import ReviewCard from "./review/ReviewCard";

const ReviewDashboard = () => {
  const reviews = useSelector((state) => state.ReputationMangerReducer.reviews);

  const data = [
    { month: "Jan", value: 120 },
    { month: "Feb", value: 132 },
    { month: "Mar", value: 101 },
    { month: "Apr", value: 134 },
    { month: "May", value: 90 },
    { month: "Jun", value: 230 },
    { month: "Jul", value: 210 },
    { month: "Aug", value: 180 },
    { month: "Sep", value: 160 },
    { month: "Oct", value: 170 },
    { month: "Nov", value: 190 },
    { month: "Dec", value: 200 },
  ];

  const config = {
    data,
    xField: "month",
    yField: "value",
    smooth: true,
    point: {
      size: 4,
      shape: "circle",
    },
    tooltip: {
      showMarkers: true,
    },
    xAxis: {
      title: {
        text: "Rating",
      },
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    legend: {
      position: "bottom",
    },
  };

  const data2 = [
    { hotel: "Hotel Royal", sentiment: "Positive", count: 120 },
    { hotel: "Hotel Royal", sentiment: "Neutral", count: 30 },
    { hotel: "Hotel Royal", sentiment: "Negative", count: 10 },

    { hotel: "Sea View", sentiment: "Positive", count: 100 },
    { hotel: "Sea View", sentiment: "Neutral", count: 50 },
    { hotel: "Sea View", sentiment: "Negative", count: 20 },

    { hotel: "City Lodge", sentiment: "Positive", count: 60 },
    { hotel: "City Lodge", sentiment: "Neutral", count: 25 },
    { hotel: "City Lodge", sentiment: "Negative", count: 15 },
  ];

  const config2 = {
    data: data2,
    isStack: true,
    xField: "hotel",
    yField: "count",
    seriesField: "sentiment",
    color: ({ sentiment }) => {
      if (sentiment === "Positive") return "#52c41a";
      if (sentiment === "Neutral") return "#94a3b8";
      return "#f5222d";
    },
    label: {
      position: "middle",
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
    legend: {
      position: "bottom",
    },
  };

  return (
    <div className="reputation-manager mt-4 mb-4 pb-4 pt-4 px-20 d-flex gap-20 flex-column">
      <Row gutter={[24, 24]}>
        <Col xs={24} md={12} lg={6}>
          <Card className="card h-100 shadow">
            <div className="d-flex align-items-start justify-content-between">
              <div className="d-flex gap-5 flex-column">
                <div className="text-gray-800 heading14px fw-semibold">
                  Average Rating
                </div>
                <div>
                  <span className="fw-bold heading24px">4.7</span>{" "}
                  <span className="text-46c75e fw-semibold">↑ 0.3%</span>
                </div>
                <div className="text-gray-800 heading12px">
                  Across all platforms
                </div>
              </div>
              <div className="bg-soft-lavender rounded w-35 h-35 d-flex align-items-center justify-content-center">
                <StarOutlined className="text-theme heading20px" />
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <Card className="card h-100 shadow">
            <div className="d-flex align-items-start justify-content-between">
              <div className="d-flex gap-5 flex-column">
                <div className="text-gray-800 heading14px fw-semibold">
                  Total Reviews
                </div>
                <div>
                  <span className="fw-bold heading24px">1,248</span>{" "}
                  <span className="text-46c75e fw-semibold">↑ 12%</span>
                </div>
                <div className="text-gray-800 heading12px">Last 30 days</div>
              </div>
              <div className="bg-soft-lavender text-theme rounded w-35 h-35 d-flex align-items-center justify-content-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="42"
                  height="42"
                  viewBox="0 0 225 225"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <g transform="translate(0,225) scale(0.1,-0.1)">
                    <path
                      d="M731 1572 c-71 -38 -71 -39 -71 -487 0 -299 3 -404 12 -413 27 -27
      55 -11 148 83 l95 95 290 0 c410 0 385 -24 385 367 0 301 -4 319 -71 355 -31
      16 -64 18 -394 18 -330 0 -363 -2 -394 -18z m753 -88 c14 -13 16 -52 16 -268
      0 -183 -3 -255 -12 -264 -9 -9 -92 -12 -311 -12 l-299 0 -64 -62 -64 -61 0
      326 c0 283 2 328 16 341 13 14 60 16 359 16 299 0 346 -2 359 -16z"
                    />
                  </g>
                </svg>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <Card className="card h-100 shadow">
            <div className="d-flex align-items-start justify-content-between">
              <div className="d-flex gap-5 flex-column">
                <div className="text-gray-800 heading14px fw-semibold">
                  Response Rate
                </div>
                <div>
                  <span className="fw-bold heading24px">92%</span>{" "}
                  <span className="text-46c75e fw-semibold">↑ 5%</span>
                </div>
                <div className="text-gray-800 heading12px">Goal: 95%</div>
              </div>
              <div className="bg-soft-lavender rounded w-35 h-35 d-flex align-items-center justify-content-center">
                <RiseOutlined className="text-theme heading20px" />
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <Card className="card h-100 shadow">
            <div className="d-flex align-items-start justify-content-between">
              <div className="d-flex gap-5 flex-column">
                <div className="text-gray-800 heading14px fw-semibold">
                  Guest Sentiment
                </div>
                <div>
                  <span className="fw-bold heading24px">76% Positive</span>{" "}
                  <span className="text-46c75e fw-semibold">↓ 2%</span>
                </div>
                <div className="text-gray-800 heading12px">Last 7 days</div>
              </div>
              <div className="bg-soft-lavender rounded w-35 h-35 d-flex align-items-center justify-content-center">
                <TeamOutlined className="text-theme heading20px" />
              </div>
            </div>
          </Card>
        </Col>
      </Row>
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={12}>
          <Card className="card h-100 shadow">
            <div className="heading24px fw-semibold">Rating Trend</div>
            <div className="text-gray-800 mb30">
              Average rating over time across all platforms
            </div>
            <Line {...config} />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card className="card h-100 shadow">
            <div className="heading24px fw-semibold">Sentiment Analysis</div>
            <div className="text-gray-800 mb30">
              Breakdown of review sentiment by property
            </div>
            <Column {...config2} />
          </Card>
        </Col>
      </Row>

      <h1 className="heading18px fw-semibold">Recent Reviews</h1>
      <ReviewCard reviews={reviews} />
    </div>
  );
};

export default ReviewDashboard;
